import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import firebase from 'firebase';
import {Link} from 'react-router-dom';
import store from '../../store';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const moment = require('moment');

const database=firebase.database();


class ReporteConductores extends Component{
	
	
	constructor(props){
		
		super(props)
		
		this.state={
			conductores:[],
			conductorestemp:[],
			socios:[],
			vehiculos:[],
			labels:['Nombre','Dui','Licencia','Socio','Estado','Vehiculo']
			
		}
		
		
		this.handleFilter=this.handleFilter.bind(this);
		this.handleClickPrint=this.handleClickPrint.bind(this);
		
		this.conductoresRef=database.ref().child('Empleados');
		this.sociosRef=database.ref().child('Socios');
		this.vehiculosRef=database.ref().child('Vehiculos');
	}
	
	
	
	componentDidMount(){
	
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);		
		
		
	}
	componentWillMount(){
		
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);		
		
		
	}
	
	
	
	
	
	gotDataSocios=(data)=>{
		
		
		
		let newSocios=[];
		
		if(data.val()!==null){
			
			let socio=data.val();
			let keys=Object.keys(socio);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
								
				if(socio[k].Nombre!==undefined){
					
					newSocios.push({
						key:k,
						nombre:socio[k].Nombre,
						apellido:socio[k].Apellido,
						estado:socio[k].Estado						
					})
				}
				
			}
			this.setState({socios:newSocios});			
			this.vehiculosRef.once('value',this.gotDataVehiculos,this.errDataVehiculos);
		}		
	}
	errDataSocios=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataVehiculos=(data)=>{
		
		let newVehiculos=[]
		
		
		if(data.val()!==null){
			
			
			let vehiculo=data.val();
			
			let keys=Object.keys(vehiculo);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				if(vehiculo[k].marca!==undefined){
		
					
		
					newVehiculos.push({
						key:k,
						base:vehiculo[k].base,
						marca:vehiculo[k].marca,
						modelo:vehiculo[k].modelo,
						estado: vehiculo[k].estado === 'desactivo' ? 'Inactivo' : vehiculo[k].estado,
						socio:vehiculo[k].codigo_socio,
						anio:vehiculo[k].anio,
						placa:vehiculo[k].placa,
						tipo_vehiculo:vehiculo[k].tipo_vehiculo						
					})
			
				}
				
			}
			this.setState({vehiculos:newVehiculos});
			
			this.conductoresRef.once('value',this.gotData,this.errData);	
			
		}
		
		
		
	}
	errDataVehiculos=(err)=>{
		
		
		console.log(err);
		
	}
	
	
	gotData=(data)=>{
		
		
		let newConductores=[]
		
		
		if(data.val()!=null){
			
			let data_conductores=data.val();
			let keys=Object.keys(data_conductores);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				
				if(data_conductores[k].nombre!==undefined){
				
					let vehiculo_nombre;
					let socio_nombre;
				
					for(let j=0;j<this.state.socios.length;j++){
						
						if(data_conductores[k].socio===this.state.socios[j].key){
							
							socio_nombre=this.state.socios[j].nombre+' '+this.state.socios[j].apellido;
						}
						
					}
					
		
					for(let h=0;h<this.state.vehiculos.length;h++){
						
						
						if(data_conductores[k].vehiculo===this.state.vehiculos[h].key){
							
							
							vehiculo_nombre=this.state.vehiculos[h].marca+' '+this.state.vehiculos[h].modelo;
							
						}
		
						
						
					}
					
					
					newConductores.push({
						key:k,
						nombre:data_conductores[k].nombre,
						correo:data_conductores[k].correo,
						direccion:data_conductores[k].direccion, 
						dui:data_conductores[k].dui,
						licencia:data_conductores[k].licencia,
						edad:data_conductores[k].edad,
						estado:data_conductores[k].estado === 'desactivo' ? 'Inactivo' : data_conductores[k].estado,
						socio:socio_nombre,
						vehiculo:vehiculo_nombre
					})				
					
				}
				
				
				
			}
			this.setState({
				conductores:newConductores,
				conductorestemp:newConductores			
			});
					
		}
		
		
	}
	errData=(err)=>{
		
		console.log(err);
		
	}
	
	
	handleFilter(){
		let { conductores, conductorestemp } = this.state;
		let newConductores=[]	
		let socio=this.socios.value;
		let estado=this.estado.value;
		for(let i=0;i<conductorestemp.length;i++){
			if(conductorestemp[i].estado !== undefined && conductorestemp[i].socio !== undefined)
			{
				let nombre_socio=conductorestemp[i].socio.toLowerCase().search(socio.toLowerCase())>=0?true:false;
				let estado_socio=conductorestemp[i].estado.toLowerCase().search(estado.toLowerCase())>=0?true:false;
				if(nombre_socio && estado_socio){
					newConductores.push({
							key:conductorestemp[i].key,
							nombre:conductorestemp[i].nombre,
							correo:conductorestemp[i].correo,
							direccion:conductorestemp[i].direccion, 
							dui:conductorestemp[i].dui,
							licencia:conductorestemp[i].licencia,
							edad:conductorestemp[i].edad,
							estado:conductorestemp[i].estado,
							socio:conductorestemp[i].socio,
							vehiculo:conductorestemp[i].vehiculo					
					})				
				}
			}
		}	
		this.setState({ conductores:newConductores})	
	}
	
	handleClickPrint() {

		const tempArr = [];
		for(var i=0; i<this.state.conductores.length; i++){
		
			tempArr.push(
				[ 
					this.state.conductores[i].nombre, 
					this.state.conductores[i].dui,
					this.state.conductores[i].licencia,
					this.state.conductores[i].correo,
					this.state.conductores[i].edad,
					this.state.conductores[i].socio || '', 
					this.state.conductores[i].estado || '',
					this.state.conductores[i].vehiculo || ''	
				]
			);
		}
		const dd = {
			columns:{
				title: 'Reporte de conductores'
			},
			pageOrientation: 'landscape',
			content: [{
				text: ''
			},
			{ text: 'Reporte de conductores',
			style: 'header'},
			{ text: moment().format('LLLL'),
			style: 'myStyle'},
			{
			table: {
			headerRows: 1,
				body: [
					[{text:'Nombre', bold:true}, {text:'DUI', bold:true}, {text:'Licencia', bold:true}, {text:'Correo', bold:true}, {text:'Edad', bold:true}, {text:'Socio', bold:true}, {text:'Estado', bold:true}, {text:'Vehiculo', bold:true}],
					...tempArr
				]
				}
				}
			],
			styles: {
				header: {
				    fontSize: 20,
					bold: true,
				    },
				    myStyle: {
				    fontSize: 9,
				    margin: [0, 9, 0, 19]             
				} 
			}
		}
		pdfMake.createPdf(dd).download('ReporteConductores');
	}
	
	
	render(){
		
		
			return(
			
			
					<div className="reporte_conductores">
						<center><h3>Reporte de conductores</h3></center>
						<div className="row">
							<div class="col-md-4">
								<a className="btn btn-success" onClick={this.handleClickPrint}><span class="glyphicon glyphicon-print" style={{color: "white"}}> Imprimir</span></a>
							</div>							
							<div class="col-md-4">
								<div className="form-group">
									<label htmlFor="socio">Socio</label>
									<input type="text" name="socio" placeholder="Socio" className="form-control"
									ref={input=>{this.socios=input}}
									onKeyUp={this.handleFilter}
									/>
								</div>						
							</div>
							<div class="col-md-4">
								<div className="form-group">
									<label htmlFor="estado">Estado</label>
									<input type="text" className="form-control" placeholder="Estado" name="estado"
									ref={input=>{this.estado=input}}
									onKeyUp={this.handleFilter}
									/>
								</div>
							</div>
							
						</div>
									
						<BootstrapTable data={ this.state.conductores }
								 ref='table'			 
								 pagination={ true }
								 search={ false }
								 hover
								 >
								 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								 <TableHeaderColumn dataField='nombre'  dataSort={true}  >Nombre</TableHeaderColumn>
								 <TableHeaderColumn dataField='dui'  dataSort={true}  >Dui</TableHeaderColumn>
								 <TableHeaderColumn dataField='licencia'  dataSort={true}  >Licencia</TableHeaderColumn>
								 <TableHeaderColumn dataField='correo'  dataSort={true}  >Correo</TableHeaderColumn>
								 <TableHeaderColumn dataField='edad'  dataSort={true}  >Edad</TableHeaderColumn>
								 <TableHeaderColumn dataField='socio'  dataSort={true}  >Socio</TableHeaderColumn>
								 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>
								 <TableHeaderColumn dataField='vehiculo'  dataSort={true}  >Vehiculo</TableHeaderColumn>				
						</BootstrapTable>
						


			
				
					</div>
			)
		
		
	}
	
}

export default ReporteConductores;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteConductores.jsx